import requests from './requests';

export default {
    get(id) {
        return requests
            .get(`/trainer/course/${id}`)
            .then(resp => resp.data);
    },
    getNext() {
        return requests
            .get('/trainer/courses/next')
            .then(resp => resp.data);
    },
    getEarlierCourses(date, time) {
        return requests
            .post('/trainer/courses/earlier', { date, time })
            .then(resp => resp.data);
    },
    getLaterCourses(date, time) {
        return requests
            .post('/trainer/courses/later', { date, time })
            .then(resp => resp.data);
    },
    createDraft(draft) {
        return requests
            .post('/trainer/course/draft', draft)
            .then(resp => resp.data);
    },
};



// WEBPACK FOOTER //
// ./src/api/course.js